<div class="app-layout">
  <div class="layout-content-wrapper" [class.expanded]="isExpanded">
    <!-- ZONA A: Menú Izquierdo (Sidebar) -->
    <aside
      class="sidebar-zone"
      [class.hidden]="isExpanded"
      [class.minimized]="sidebarMinimized"
    >
      <app-sidebar
        [minimized]="sidebarMinimized"
        [seusMenus]="seusMenus()"
        (minimizedChange)="sidebarMinimized = $event"
      ></app-sidebar>
    </aside>

    <!-- ZONA B: Contenedor del Navbar + Contenido Principal -->
    <div class="zone-b" [class.expanded]="isExpanded">
      <app-navbar
        [user]="userForNavbar()"
        [userMenuActive]="userMenuActive"
        [isExpanded]="isExpanded"
        (userMenuActiveChange)="userMenuActive = $event"
        (logout)="logout()"
      ></app-navbar>
      <!-- Contenido Principal -->
      <main class="main-content" [class.expanded]="isExpanded">
        <div class="content-wrapper">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>

  <!-- Toast global para mostrar mensajes de error -->
  <app-toast></app-toast>
</div>
